import { useState } from "react"

import { Button } from "@minuthq/meatball-ui-react"

import { CreateTaskTemplateDialog } from "src/components/TaskManagement/templates/CreateTaskTemplateDialog"
import { useTranslate } from "src/i18n/useTranslate"
import { Titlebar } from "src/ui/Layout/Titlebar"

export function TaskTemplates() {
  const { t, langKeys } = useTranslate()

  const [openDialog, setOpenDialog] = useState(false)

  return (
    <div>
      <Titlebar
        title={t(langKeys.template_plural)}
        titleVariant="heading2"
        description={t(langKeys.task_management_templates_description)}
        actionBar={
          <Button onClick={() => setOpenDialog(true)}>
            {t(langKeys.create_a_template)}
          </Button>
        }
        size="unset"
      />

      {openDialog && (
        <CreateTaskTemplateDialog onClose={() => setOpenDialog(false)} />
      )}
    </div>
  )
}
